import {
  IconDefinition,
  faCheck,
  faCircleNotch,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Tag } from '.';
import { IndexBuildStatus, Intent } from '../types';

const indexBuildStatusTagStyles: {
  [key in IndexBuildStatus]: {
    icon: IconDefinition;
    intent: Intent;
    label: string;
  };
} = {
  ready: {
    icon: faCheck,
    intent: 'success',
    label: 'Ready',
  },
  building: {
    icon: faCircleNotch,
    intent: 'info',
    label: 'Building',
  },
  failed: {
    icon: faTriangleExclamation,
    intent: 'danger',
    label: 'Build failed',
  },
};

type IndexBuildStatusTagProps = {
  buildStatus: IndexBuildStatus;
  show?: boolean;
  [key: string]: any;
};

export function IndexBuildStatusTag({
  buildStatus,
  show = true,
  ...props
}: IndexBuildStatusTagProps): ReactElement {
  const { icon, intent, label } = indexBuildStatusTagStyles[buildStatus];

  return (
    <Tag show={show} intent={intent} icon={icon} {...props}>
      {label}
    </Tag>
  );
}
